module.exports = __webpack_public_path__ + "img/bba284ac05b041a8b8b0d1927868d5c9x.e1b4e64b.jpg";